/** Zárt csoportok — a fejléc, a fiók-menü és a csatlakozás tiszta címke- és útvonal-segédei. */
import { CustomerGroupBrief, GroupDiscountInfo } from '../../types/customerGroups';

/** A fejléc-gomb csoportnevének legnagyobb hossza (utána „…”, a teljes név tooltipben). */
export const GROUP_NAME_MAX = 18;

export const shortGroupName = (name: string, max: number = GROUP_NAME_MAX): string =>
  name.length <= max ? name : `${name.slice(0, max - 1).trimEnd()}…`;

export const isTruncated = (name: string, max: number = GROUP_NAME_MAX): boolean => name.length > max;

export const groupButtonLabel = (groups: CustomerGroupBrief[]): string =>
  groups.length === 1 ? `★ ${shortGroupName(groups[0].name)}` : `★ Csoportjaim (${groups.length})`;

/** Van-e csoport-kedvezmény (a „0.00” = nincs). */
export const hasDiscount = (info: GroupDiscountInfo): boolean => Number(info.discount_percent) > 0;

/** A kedvezmény-% magyarul: „10.00” → „10%”, „12.50” → „12,5%” (fölösleges nullák nélkül). */
export const formatPercent = (percent: string): string =>
  `${String(Number(percent)).replace('.', ',')}%`;

/** A „Csoportjaim” lenyíló egy sora: „OMTK-ULE · 10%”; kedvezmény nélkül csak a név. */
export const groupMenuRowLabel = (group: CustomerGroupBrief): string =>
  hasDiscount(group) ? `${group.name} · ${formatPercent(group.discount_percent)}` : group.name;

/** A csoport-oldal / „Csoportjaim” kedvezmény-mondata a hatókör szerint; kedvezmény nélkül null. */
export const discountLine = (info: GroupDiscountInfo): string | null => {
  if (!hasDiscount(info)) return null;
  const target = info.discount_scope === 'all_products' ? 'minden termékre' : 'a csoport termékeire';
  return `${formatPercent(info.discount_percent)} tagi kedvezmény ${target}`;
};

export const MULTIPLE_DISCOUNT_NOTE =
  'Több kedvezményes csoportnak is tagja vagy — mindig a legnagyobb kedvezmény érvényes.';

export const accountMenuLabel = (group: CustomerGroupBrief): string => `★ ${group.name} termékek`;

export const groupPagePath = (slug: string): string => `/csoport/${encodeURIComponent(slug)}`;

export const joinPagePath = (code: string): string => `/csatlakozas/${encodeURIComponent(code)}`;

export const loginForJoinPath = (code: string): string =>
  `/bejelentkezes?next=${encodeURIComponent(joinPagePath(code))}`;

/** Regisztráció a kóddal: a regisztráció maga csatlakoztat (invite_code), ezért NINCS
 *  `next=/csatlakozas/…` — különben a kód kétszer fogyasztana a próbálkozási keretből. */
export const registerForJoinPath = (code: string): string => `/regisztracio?meghivo=${encodeURIComponent(code)}`;

export const pendingWelcome = (groups: CustomerGroupBrief[] | undefined): CustomerGroupBrief | null =>
  (groups ?? []).find((group) => group.welcome_pending) ?? null;
